<template>
    <div class="row">
        <!-- FILTRO GLOBAL (una sola vez) -->
        <div class="col-12" style="z-index: 999;">
            <div class="row">
                <div class="col-md-6">
                    <label>Usuario</label>
                    <select class="form-control" v-model="search.user_id">
                        <option value="">Todos</option>
                        <option v-for="(user, index) in catalogue.users_programs"
                            :value="user.user_id + '|' + user.company_id" :key="index">
                            {{ user.name }} {{ user.last_name }} <span v-if="user.company"> - {{ user.company.name
                                }}</span>
                        </option>
                    </select>
                </div>
                <div class="col-md-6">
                    <br>
                    <button class="btn btn-sm btn-outline-success float-right" @click="exportContributions" v-if="type==1">
                        <i class="fa fa-plus"></i> Exportar
                    </button>
                    <button class="btn btn-sm btn-outline-success float-right" @click="exportContributions" v-if="type==2">
                        <i class="fa fa-plus"></i> Exportar
                    </button>
                </div>
                <div class="col-md-12">
                    <hr>
                </div>
            </div>
        </div>

        <!-- LISTA POR GRUPO -->
        <div class="card card-primary card-tabs w-100">
            <div class="card-header p-0 pt-1">
                <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="custom-tabs-one-home-tab" data-toggle="pill" @click="type = 1"
                            href="#custom-tabs-one-home" role="tab" aria-controls="custom-tabs-one-home"
                            aria-selected="true">Reporte de pagos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="pill" @click="type = 2"
                            href="#custom-tabs-one-profile" role="tab" aria-controls="custom-tabs-one-profile"
                            aria-selected="false">Reporte
                            general</a>
                    </li>
                </ul>
            </div>
            <div class="card-body bd">
                <div class="tab-content" id="custom-tabs-one-tabContent">
                    <div class="tab-pane fade show active" id="custom-tabs-one-home" role="tabpanel"
                        aria-labelledby="custom-tabs-one-home-tab">
                        <div class="col-12" v-for="group in (contributions.groups || [])" :key="group.id">
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="btn btn-sm btn-outline-success float-right"
                                        v-can="'add_programs_investors'"
                                        @click="openContributionIndefiniteModal(group.id)">
                                        <i class="fa fa-plus"></i> Aportar
                                    </button>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="mb-4 table-responsive">
                                        <table class="table table-bordered text-center text-sm">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Usuario</th>
                                                    <th>Compañía</th>
                                                    <th>Tipo de movimiento</th>
                                                    <th>Fecha</th>
                                                    <th>Monto</th>
                                                    <th>Opciones</th>
                                                </tr>
                                            </thead>

                                            <tbody v-if="loading">
                                                <tr>
                                                    <td align="center" colspan="6">
                                                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                                        <h5>Cargando</h5>
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody v-else-if="filteredContributionsByGroup(group).length > 0">
                                                <tr v-for="(contribution, index) in filteredContributionsByGroup(group)"
                                                    :key="index">
                                                    <td>{{ contribution.id }}
                                                    </td>

                                                    <td>
                                                        <span v-if="contribution.user">
                                                            {{ contribution.user.name }} {{ contribution.user.last_name
                                                            }}
                                                        </span>
                                                        <span v-else>No hay usuario</span>
                                                    </td>
                                                    <td>
                                                        <span v-if="contribution.company">
                                                            {{ contribution.company.name }}
                                                        </span>
                                                        <span v-else>No hay compañía</span>
                                                    </td>

                                                    <td>
                                                        <span v-if="contribution.type_payments">
                                                            {{ contribution.type_payments.name }}
                                                        </span>
                                                        <span v-else>No hay tipo</span>
                                                    </td>

                                                    <td>
                                                        {{ contribution.date | toDateTime }}
                                                    </td>

                                                    <td>
                                                        {{ contribution.amount | toCurrency }}
                                                    </td>

                                                    <td>

                                                        <button class="btn btn-sm btn-outline-info m-1"
                                                            @click="showMovement(contribution)">
                                                            <i class="fa fa-eye"></i> Ver movimiento
                                                        </button>

                                                        <button class="btn btn-sm btn-outline-danger m-1"
                                                            v-can="'delete_programs_investors'"
                                                            @click="deleteContribution(contribution.id)">
                                                            <i class="fa-solid fa-trash"></i> Eliminar
                                                        </button>
                                                        <a class="btn btn-sm btn-outline-info m-1" target="_blank"
                                                            :href="`${globalUrlFiles}/contributions?program_id=${contribution.id}`">
                                                            <i class="fa-solid fa-file"></i> Recibo
                                                        </a>
                                                        <button class="btn btn-sm btn-outline-primary m-1"
                                                            @click="sendVoucher(contribution.id, contribution.user.email)">
                                                            <i class="fa-solid fa-envelope"></i> Enviar recibo
                                                        </button>

                                                        <h5 v-if="contribution.send == 1"><span
                                                                class="badge bg-success notification-badge m-1">
                                                                <i class="fa-regular fa-circle-check"></i> Correo
                                                                enviado</span>
                                                        </h5>
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody v-else>
                                                <tr>
                                                    <td align="center" colspan="7">Sin resultados.</td>
                                                </tr>
                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <th colspan="4">Total</th>
                                                    <th>{{ totalByGroup(group) | toCurrency }}</th>
                                                    <th colspan="2"></th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel"
                        aria-labelledby="custom-tabs-one-profile-tab">


                        <div class="row">
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm table-contributions" :key="index"
                                    v-for="(group, index) in contributionsGroups.groups">
                                    <thead>
                                        <tr>
                                            <th style="background-color:#859dcd; color: white; padding: 10px;"
                                                class="text-center" colspan="5">{{ group.name }}</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center">SOCIOS</th>
                                            <th class="text-center" colspan="4">APORTACIONES PAGADAS</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center"></th>
                                            <th class="text-center">PORCENTAJE</th>
                                            <th class="text-center">TRANSFERENCIAS</th>
                                            <th class="text-center">EFECTIVO</th>
                                            <th class="text-center">TOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="user in group.users" :key="user.id">
                                        <tr>
                                            <td class="text-center">{{ user.user }}</td>
                                            <td class="text-center">{{ user.percentage }} %</td>                                           
                                            <td class="text-right">{{ user.pays && user.pays[2] ? user.pays[2].total : 0
                                                | toCurrency }}</td>
                                            <td class="text-right">{{ user.pays && user.pays[5] ? user.pays[5].total : 0
                                                | toCurrency }}</td>
                                            <td class="text-right">{{ user.total_user | toCurrency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="grand-total-row" style="background: #dadada;">
                                            <td colspan="2" class="text-center">TOTAL</td>
                                            <td class="text-right">{{ group.transfers | toCurrency }}</td>
                                            <td class="text-right">{{ group.cash | toCurrency }}</td>
                                            <td class="text-right">{{ group.total_group | toCurrency }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <table class="table table-bordered table-sm w-100">
                                    <thead style="background-color:#859dcd; color: white; padding: 10px;">
                                        <tr >
                                            <td class="text-center">Total efectivo</td>
                                            <td class="text-center">Total trasferencia</td>
                                            <td class="text-center">Total general</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>                                          
                                            <td class="text-right">{{ contributionsGroups.program.total_efectivo | toCurrency }}</td>
                                            <td class="text-right">{{ contributionsGroups.program.total_transfer | toCurrency }}</td>
                                            <td class="text-right">{{ contributionsGroups.program.total | toCurrency }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </div>

        <ModalFormComponent />
    </div>
</template>

<script>
import request from "@/services/request";
import { mapActions } from "vuex";
import ModalFormComponent from "@/components/programs/indefinite/ModalFormComponent.vue";
import Catalogue from "@/services/catalogue";

export default {
    name: "list-indefinite",
    components: {
        ModalFormComponent,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            loading: true,
            contributions: { groups: [] },
            companies: [],
            program_id: this.$route.params.id,
            search: {
                user_id: "", // filtro global (front)
            },
            contributionsGroups: {},
            type: 1,
            errors: null,
            edit: true
        };
    },
    methods: {
        showMovement(contribution) {
            Event.$emit("event-show-program-group-contribution", contribution);
        },
        exportContributions() {
            let _url = '';
            if (this.type == 1) {
                _url = this.globalUrlFiles + '/programs_investors/export?user_id=' + this.search.user_id + '&program_id=' + this.program_id;
            } else {
                _url = this.globalUrlFiles + `/programs/${this.program_id}/contributions-indefinite-groupby-export`;
            }
            window.open(_url, '_blank');
        },

        // Filtra contributions por grupo sin pegar a backend
        filteredContributionsByGroup(group) {
            const list = group?.contributions ?? [];
            const value = this.search.user_id; // "user_id|company_id" o ""

            if (!value) return list;

            const [userId, companyId] = String(value).split("|").map(Number);

            return list.filter((c) => {
                const cUserId = Number(c.user_id ?? c.user?.id);
                const cCompanyId = Number(c.company_id ?? c.company?.id);
                return cUserId === userId && cCompanyId === companyId;
            });
        },

        totalByGroup(group) {
            const list = this.filteredContributionsByGroup(group);
            return list.reduce((sum, c) => sum + Number(c.amount || 0), 0);
        },

        async loadContributions() {
            this.loading = true;

            try {
                const { data } = await request.get(
                    `/programs/${this.program_id}/contributions-indefinite`
                );

                this.contributions = data || { groups: [] };
            } catch (error) {
                console.log(error);
                this.errors = await this.errorNotification(error);
            } finally {
                this.loading = false;
                this.loadContributionsGroups();
            }
        },

        async loadContributionsGroups() {
            this.loading = true;
            try {
                const { data } = await request.get(`/programs/${this.program_id}/contributions-indefinite-groupby`);
                this.contributionsGroups = data;
            } catch (error) {
                console.log(error);
                this.errors = await this.errorNotification(error);
            } finally {
                this.loading = false;
            }
        },

        openContributionIndefiniteModal(group_id) {
            Event.$emit("event-open-program-group-unidirectional-contribution", group_id);
        },

        deleteContribution(id) {
            let tit = "Eliminar aportación";
            let txt = "Seguro que quiere eliminar la aportación";

            this.$swal({
                title: tit,
                text: txt,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Ok",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.callDeleted(id);
                }
            });
        },
        sendVoucher(contributionId, email) {
            Event.$emit("event-send-voucher-contribution", contributionId, email);
        },

        async callDeleted(id) {
            let _endpoint = "/program-group-contributions/" + id;

            try {
                let response = await request.destroy(_endpoint).then(function (response) {
                    return response;
                });

                await this.loadContributions();
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },
    mounted() {
        this.catalogue.get_users_programs(this.$route.params.id);
        this.loadContributions();
    },
    created() {
        Event.$on("event-reload-program-relations-current", () => {
            this.loadContributions();
        });
    },
    watch: {
        search: {
            handler() {
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.notification-badge {
    border-radius: 30px;
    padding: 7px;
}

.progress {
    background-color: #e9ecef;
}

.progress-bar {
    transition: width 0.5s;
}

.card-primary:not(.card-outline)>.card-header {
    background-color: #224c83;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #ffffff !important;
    background-color: #859dcd;
    border-color: #dee2e6 #dee2e6 #fff;
}

.bd {
    border: 1px solid #dcdcdc;
    border-radius: 0px 0px 10px 10px;
}
</style>
